<!--
<create-dialog title="Klant aanmaken" :event="save" @close="close" @open="open">
    <fields v-model="newCustomer" :validations="$v.newCustomer" />

    <template v-slot:button="{ on, attrs }">
         <v-btn text v-bind="attrs"
                v-on="on">
             Custom button <v-icon small>mdi-plus</v-icon>
         </v-btn>
    </template>
</create-dialog>
-->
<template>
    <v-dialog v-model="dialog" :width="width" :transition="false" :fullscreen="fullscreen" persistent scrollable>
        <template v-slot:activator="{ on, attrs }">
            <slot name="button" v-bind="{ on, attrs }">
                <v-btn
                    absolute
                    color="success"
                    dark
                    fab
                    right
                    small
                    top
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </slot>
        </template>
        <v-card>
            <v-toolbar flat dark color="primary" max-height="64">
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="!loading && dialog" class="pt-4">
                <slot></slot>
            </v-card-text>
            <v-card-text v-if="loading" class="text-center">
                <v-icon color="primary" class="ma-4">mdi-loading mdi-spin</v-icon>
            </v-card-text>
            <v-card-actions>
                <v-btn color="secondary" outlined @click="dialog = false">Annuleren</v-btn>
                <v-spacer></v-spacer>
                <event-button color="success" :event="save">{{ sendButtonText }}</event-button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EventButton from "@/components/General/Button/EventButton";

export default {
    components: {
        EventButton,
    },
    props: {
        title: {
            required: true,
            type: String,
        },
        event: {
            required: true,
        },
        loading: {
            default: false,
            type: Boolean,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        width: {
            required: false,
            type: Number,
            default: 800,
        },
        sendButtonText:{
            required: false,
            type: String,
            default: 'Toevoegen',
        },
        forceState: {
            type: Boolean,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
        }
    },
    watch: {
        forceState(state) {
            if (state !== null) {
                this.dialog = state;
            }
        },
        dialog(visible) {
            if (visible) {
                this.$emit('open');
            } else {
                this.$emit('close');
            }
        }
    },
    methods: {
        save() {
            let response = this.event();

            if (response && response.then && typeof response.then === 'function') {
                return response.then(() => {
                    this.dialog = false;
                });
            }
            return Promise.resolve();
        },
    },
}
</script>
